import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from 'src/app-constants';
import { TokenRequestSM } from 'src/app/service-models/token/token-request-s-m';
import { AccountService } from 'src/app/services/account.service';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { StorageService } from 'src/app/services/storage.service';
import { LoginViewModel } from 'src/app/view-models/login.viewmodel';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    RouterLink
  ],
  standalone: true,
})

export class LoginComponent {


  @Input() request!: TokenRequestSM;

  viewModel!: LoginViewModel;

  constructor(public activeModal: NgbActiveModal, private _commonService: CommonService,
    private accountService: AccountService, private _exceptionHandler: LogHandlerService,
    private router: Router,
    private storageService: StorageService) {
    this.viewModel = new LoginViewModel();
    this.viewModel.tokenRequest = this.request ? new TokenRequestSM() : this.request;
    this.viewModel.tokenRequest = new TokenRequestSM();
  }
  // async ngOnInit() {
  //   await this.loadPageData();
  // }


  //   async loadPageData() {
  //     try {
  //       let rememberMe = await this.storageService.getFromStorage(AppConstants.DbKeys.REMEMBER_ME);
  //       if (rememberMe != null && rememberMe === true) {
  //         this.viewModel.tokenRequest.loginId = await this.storageService.getFromStorage(AppConstants.DbKeys.USER_ID);
  //         this.viewModel.tokenRequest.password = await this.storageService.getFromStorage(AppConstants.DbKeys.LOGIN_USER);
  //       }
  //     } catch (error) {
  //       throw (error)
  //     }
  // }


  togglePassword() {
    this.viewModel.hide = !this.viewModel.hide;
    if (this.viewModel.eyeDefault == 'default') {
      this.viewModel.eyeDefault = 'eyeChange';
    } else {
      this.viewModel.eyeDefault = 'default';
    }
    return;
  }


  async click_Login() {
    // this.viewModel.isFormSubmitted = true;
    //     this.activeModal.close(true);
    // return;
    try {
      if (!this.submit())
        return;

      // await this._commonService.presentLoading();
      //have to do paging
      let resp = await this.accountService.generateToken(this.viewModel.tokenRequest, this.viewModel);
      if (resp.isError) {
        this._exceptionHandler.logObject(resp.errorData);
        this._commonService.presentToast({
          header: 'Error!',
          body: resp.errorData.displayMessage, delay: 5000,
          className: 'TopRight bg-danger text-light', animation: true
        });
      }
      else {
        this.activeModal.close(true);

        if (resp.successData.accessToken != null)
          // logic
          // this.viewModel.tokenResponse = resp.successData;
          this.router.navigate([AppConstants.WebRoutes.Home]);
      }
    } catch (error) {
      this._commonService.presentToast({
        header: 'Error!',
        body: AppConstants.ErrorPrompts.Unknown_Error, delay: 5000,
        className: 'TopRight bg-danger text-light', animation: true
      });
      throw error;
    }
    finally {
      await this._commonService.dismissLoader()
    }
  }

  submit(): any {
    let formValid = true;
    // this.viewModel.removeValidationErrors();

    // if (this.viewModel.tokenRequest.loginId == undefined || this.viewModel.tokenRequest.loginId == '') {
    //   this.viewModel.setValidationError('loginId', ErrType.Required);
    //   formValid = false;
    // }
    // if (this.viewModel.tokenRequest.password == undefined || this.viewModel.tokenRequest.password == '') {
    //   this.viewModel.setValidationError('password', ErrType.Required);
    //   formValid = false;
    // }

    // alert(JSON.stringify(this.viewModel.validationMessages))
    return formValid;

  }
}
